import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
// import { Gtag } from 'angular-gtag';
import { BehaviorSubject, Observable } from 'rxjs';
import firebase from 'firebase/compat/app';


export class User {
    uid: string
    email: string
    displayName: string
    photoURL: string
    phoneNumber: string

    videosOwned: string[]

    constructor(jsonObj?: any) {
        if (jsonObj == undefined) {
            jsonObj = {}
        }
        this.uid = jsonObj.uid ? jsonObj.uid : null
        this.photoURL = jsonObj.photoURL ? jsonObj.photoURL : null
        this.phoneNumber = jsonObj.phoneNumber ? jsonObj.phoneNumber : null
        this.email = jsonObj.email ? jsonObj.email : null
        this.displayName = jsonObj.displayName ? jsonObj.displayName : null

        this.videosOwned = jsonObj.videosOwned ? jsonObj.videosOwned : []
    }

    getSave() {
        return {
            uid: this.uid,
            photoURL: this.photoURL,
            phoneNumber: this.phoneNumber,
            email: this.email,
            displayName: this.displayName,
            videosOwned: this.videosOwned
        }
    }

}

export class AdminUser {
    isAdmin: boolean = false

    constructor(jsonObj?: any) {
        if (jsonObj.isAdmin != undefined) {
            this.isAdmin = (jsonObj && jsonObj.isAdmin) ? jsonObj.isAdmin : false
        }
        if (jsonObj.admin != undefined) {
            this.isAdmin = (jsonObj && jsonObj.admin) ? jsonObj.admin : false
        }
    }

    getSave(): any {
        return {
            isAdmin: this.isAdmin
        }
    }
}



@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public phoneNumber: string = ''
    private loginState: boolean
    private loading: boolean

    // public itemDoc: AngularFirestoreDocument<User>
    public itemDocAdminUser!: AngularFirestoreDocument<AdminUser>;
    public adminUserObs!: Observable<AdminUser>;
    // public siteUserObs: Observable<SiteUser>
    public user!: User | null;
    public adminUser: AdminUser | undefined
    // public siteUser: SiteUser

    public loginObs!: Observable<boolean>;

    public isLogin$: BehaviorSubject<boolean>;
    public isAdmin$: BehaviorSubject<boolean>;

    public isLoginPopupOn: boolean = false;

    constructor(
        private afs: AngularFirestore,
        public afAuth: AngularFireAuth,
        public router: Router,
        public ngZone: NgZone, // NgZone service to remove outside scope warning
        private http: HttpClient,
        // private gtag: Gtag,
    ) {
        this.loginState = false
        this.loading = true

        this.isLogin$ = new BehaviorSubject<boolean>(false);
        this.isAdmin$ = new BehaviorSubject<boolean>(false);

        this.afAuth.user.subscribe((user: { uid: string; } | null) => {
            if (user != null) {
                this.loginState = true

                // this.itemDoc = this.afs.doc<User>('users/' + user.uid)
                // this.itemDoc.valueChanges().subscribe(data => {
                    // console.log(data)
                    // if (data == undefined) {
                        // this.user = new User(user)
                        // this.itemDoc.set(<User>this.user.getSave())

                        // this.gtag.event('registration', {
                        //     method: 'Google',
                        //     event_category: 'engagemnt',
                        //     event_label: 'New user registered'
                        // });
                    // }
                    // else {
                        // this.user = new User(data)
                        // this.isLogin$.next(true)
                        // this.loginObserver.complete()
                        // this.gtag.event('login', {
                        //     method: 'Google',
                        //     event_category: 'engagemnt',
                        //     event_label: 'User Login'
                        // });
                    // }
                    this.initAdmin(user.uid)
                // })
            }
            else {
                this.loginState = false
                this.user = null
            }
            this.loading = false
        });

    }

    initAdmin(uid: string) {
        try {

            this.itemDocAdminUser = this.afs.doc<AdminUser>('admin/' + uid)
            this.itemDocAdminUser.valueChanges()
            .subscribe((data: AdminUser | undefined) => {
                console.log(data)
                if (data == undefined) {
                    // this.user = new User()
                    // this.itemDoc.set(this.user.getSave())
                }
                else {
                    this.adminUser = new AdminUser(data)
                    if (this.adminUser.isAdmin) {
                        console.log('Calling admin methods')
                        // this.page.addVideo()
                        this.isAdmin$.next(true);
                    }
                    else {
                        this.isAdmin$.next(false);
                    }
                    // this.isLogin$.next(true)
                    // this.loginObserver.complete()
                }
            }, (error: any) => {
                // console.info('Caught error:' + error)
                this.isAdmin$.next(false);
            })
        }
        catch(e) {}
    }

    login() {
        let promise = new Promise((resolve, reject) => {
            this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then((data: unknown) => {
                // console.log('sign in' + data)
                resolve(data)
            }).catch((error: any) => {
                reject()
            })
        })
        return promise

    }

    loginWithPhone(phone: string) {
        
        
    }

    logout() {
        let promise = new Promise((resolve, reject) => {
            this.afAuth.signOut().then((data: any) => {
                console.log('signedOut')
                resolve(data)
            }).catch((error: string) => {
                console.error('sign out error:' + error)
                reject()
            });
        })
        return promise
    }

    isLoggedIn() {
        return this.loginState;
    }

    showLogin() {
        this.isLoginPopupOn = true
    }

    closeLogin() {
        this.isLoginPopupOn = false
    }


}

